import { Injectable } from '@angular/core';
import {
  loadImage,
  loadImageBlob,
  loadImageData,
} from '../misc-utilities/image-utils';

@Injectable({ providedIn: 'root' })
export class LoadImageService {
  // this service exists to be able to stub these functions in tests

  loadImage = loadImage;
  loadMask = loadImageData;
  loadImageBlob = loadImageBlob;
}
